import React from 'react';
import styles from './NavCard.module.scss';
import PropTypes from 'prop-types';

class NavCard extends React.Component {

    state = {
        carditemActived: false // 当前导航卡是否在活动中
    }

    componentDidMount() {
        const { firstCardPath, rItem, secondCardPath } = this.props;
        const compCardPath = firstCardPath + rItem.path;
        if (secondCardPath === compCardPath) {
            this.setState({ carditemActived: true });
        }
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        const { firstCardPath, rItem, secondCardPath } = newProps;
        const compCardPath = firstCardPath + rItem.path;
        // 点击Card分类时，若隐藏则打开；若已打开则隐藏
        if (secondCardPath === compCardPath) {
            this.setState({ carditemActived: true }); // 打开
        } else {
            this.setState({ carditemActived: false }); // 隐藏
        }
    }

    render() {
        const { firstCardPath, rItem, secondCardHandle, thirdCardHandle, thirdCardPath } = this.props;
        const cardPath = firstCardPath + rItem.path;
        const cardTitle = rItem.title;
        let cnodes = [];
        if (rItem.childrenNode && Array.isArray(rItem.childrenNode)) {
            cnodes = rItem.childrenNode.filter((cNode) => {
                if (cNode.show != 'none') {
                    return true;
                }
            });
        }
        const mt = -(cnodes.length * 40) + 'px';

        return (
            <div className={`${styles.navcard} ${this.state.carditemActived ? styles.navcard_actived : ''}`}>
                <div className={`${styles.cardhome} ${this.state.carditemActived ? styles.cardhome_actived : ''}`} onClick={() => secondCardHandle(cardPath, rItem)}>
                    <div className={`${styles.title} ${this.state.carditemActived ? styles.title_actived : ''}`}>{rItem.title}</div>
                    {cnodes.length > 0 ? <img className={styles.expand} src={this.state.carditemActived ? (require('@/assets/image/shangla.png')).default : (require('@/assets/image/xiala.png')).default} /> : null}
                </div>
                <div
                    className={styles.carditem_animate}
                    style={this.state.carditemActived ? { marginTop: '0px' } : { marginTop: mt }}
                >
                    {
                        rItem.childrenNode && rItem.childrenNode.map((cNode) => {
                            const cardItemPath = firstCardPath + rItem.path + cNode.path;
                            const cardItemTitle = cNode.title;
                            const breadcrumbPaths = [].concat({ title: cardTitle, path: cardPath }, { title: cardItemTitle, path: cardItemPath }); // 面包屑导航数据
                            let ele = null;
                            if (cNode.show != 'none') {
                                // 若当前的路由路径和cardItem自身路由路径相同时，样式触发为actived
                                ele = (
                                    <div className={`${cardItemPath === thirdCardPath ? styles.active_carditem : ''} ${styles.carditem}`} key={cardItemPath} onClick={() => thirdCardHandle(cardItemPath, breadcrumbPaths)}>
                                        <div className={styles.itemtitle}>{cNode.title}</div>
                                    </div>
                                );
                            }
                            return ele;
                        })
                    }
                </div>
            </div>
        );
    }
}

NavCard.propTypes = {
    history: PropTypes.object, // history对象
    match: PropTypes.object, // match对象
    rItem: PropTypes.object, // 导航对象数据
    isToggleCard: PropTypes.bool, // 用于区别当前用户点击的是二级导航还是三级导航，true表示点击二级导航
    firstCardPath: PropTypes.string, // 一级导航路径
    secondCardPath: PropTypes.string, // 二级导航路径
    secondCardHandle: PropTypes.func, // 点击二级导航
    thirdCardPath: PropTypes.string, // 三级导航路径
    thirdCardHandle: PropTypes.func, // 点击三级导航
};

export default NavCard;